import { MassAnswerChecklistItem } from './mass-answer-checklist-item';

export class MonitorInteractionUpdateDTO {
  public interactionId?: number;
  public checkListItems: MassAnswerChecklistItem[];
}
